import { useParams } from 'react-router-dom';
import AppShell from '@/pages/client/apps/components/AppShell';
import ZifekNotesPage from '@/pages/client/apps/notes/page';
import ZifekTasksPage from '@/pages/client/apps/tasks/page';
import ZifekFlashcardsPage from '@/pages/client/apps/flashcards/page';
import ZifekStudyAiPage from '@/pages/client/apps/study-ai/page';
import DocumentsPage from '@/pages/dashboard/apps/documents/page';
import { getClientApp } from '@/lib/clientApps';

/**
 * Hôte des mini-applications du compte utilisateur.
 * Chaque app a sa propre page ; l'installation et la disponibilité sont
 * vérifiées par AppShell (Zifek Documents n'exige pas d'installation).
 */
export default function ClientAppHost() {
  const { slug } = useParams<{ slug: string }>();
  const appSlug = slug || '';

  if (appSlug === 'zifek-notes') return <ZifekNotesPage />;
  if (appSlug === 'zifek-tasks') return <ZifekTasksPage />;
  if (appSlug === 'zifek-flashcards') return <ZifekFlashcardsPage />;
  if (appSlug === 'zifek-study-ai') return <ZifekStudyAiPage />;
  if (appSlug === 'zifek-documents') {
    return (
      <AppShell slug="zifek-documents">
        <DocumentsPage />
      </AppShell>
    );
  }

  const known = getClientApp(appSlug);
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <i className="ri-compass-4-line text-3xl text-foreground-300 mb-3"></i>
      <h2 className="text-base font-semibold text-foreground-900">Application introuvable</h2>
      <p className="text-sm text-foreground-500 mt-1">
        {known ? 'Cette application n’est pas encore disponible.' : 'Cette adresse ne correspond à aucune application.'}
      </p>
    </div>
  );
}